// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__+pTZ5","message":"Toast_message__jVoBJ"};